export const generateUrlParams = (params) => {
    const urlSearchParams = new URLSearchParams();

    const paramsArray = Object.entries(params);

    paramsArray.forEach((param) => {
        if (param[1] !== undefined && param[1] !== '') {
            if (Array.isArray(param[1])) {
                if (param[1].length > 0) {
                    param[1].forEach((subParam) => {
                        urlSearchParams.append(param[0], subParam);
                    });
                }
            } else {
                urlSearchParams.append(param[0], param[1]);
            }
        }
    });

    return urlSearchParams;
};
